import * as React from 'react';
import classNames from 'classnames';
import Col from '../grid/col';
import Tooltip from '../tooltip';
import QuestionCircle from '../icon/QuestionCircle';
import { FormContext } from './context';
const FormItemLabel = ({ prefixCls, label, htmlFor, labelCol, labelAlign = 'left', required, tooltip, }) => {
    if (!label)
        return null;
    return (<FormContext.Consumer key="label">
      {({ labelAlign: contextLabelAlign, labelCol: contextLabelCol }) => {
        const mergedLabelCol = labelCol || contextLabelCol || {};
        const mergedLabelAlign = labelAlign || contextLabelAlign;
        const labelClsBasic = `${prefixCls}-item-label`;
        const labelColClassName = classNames(labelClsBasic, mergedLabelAlign === 'left' && `${labelClsBasic}-left`, mergedLabelCol.className);
        const labelChildren = label;
        const labelClassName = classNames({
            [`${prefixCls}-item-required`]: required,
        });
        return (<Col {...mergedLabelCol} className={labelColClassName}>
            <label htmlFor={htmlFor} className={labelClassName} title={typeof label === 'string' ? label : ''}>
              {labelChildren}
            </label>
            {tooltip && (<Tooltip title={tooltip}>
                <QuestionCircle className={`${prefixCls}-item-tooltip`}/>
              </Tooltip>)}
          </Col>);
    }}
    </FormContext.Consumer>);
};
export default FormItemLabel;
